import { useMemo } from "react";
const sortValue = (noti) => {
    let value = noti.createdTime;
    if (noti.progress !== undefined || noti.type === "activity") {
        value /= 10;
    }
    return value;
};
const inverseSort = (lhs, rhs) => {
    return sortValue(lhs) - sortValue(rhs);
};
export const useNotificationItems = ({ filtered, expand, }) => {
    return useMemo(() => {
        const collapsed = {};
        const seenIds = new Set();
        const items = filtered
            .slice()
            .reduce((previous, notification) => {
            if (notification.id !== undefined && seenIds.has(notification.id)) {
                return previous;
            }
            if (notification.id !== undefined) {
                seenIds.add(notification.id);
            }
            if (notification.group !== undefined && notification.group !== expand) {
                if (collapsed[notification.group] === undefined) {
                    previous.push(notification);
                    collapsed[notification.group] = 0;
                }
                collapsed[notification.group]++;
            }
            else {
                previous.push(notification);
            }
            return previous;
        }, [])
            .sort(inverseSort);
        return { items, collapsed };
    }, [filtered, expand]);
};
